import { borderGrey } from 'common/constants/colors';

export const bulkAddUsersPageHeaderStyles = {
  backgroundColor: borderGrey,
  padding: '10px',
};

export default { bulkAddUsersPageHeaderStyles };
